<div class="card">

  <div class="card-image">
    <!-- BADGES -->
    <span *ngIf="event.isSoldout" class="label label-rounded label-error">{{ 'label_sold_out' | translate }}</span>
    <span *ngIf="event.isFree" class="label label-rounded label-success">{{ 'label_program_with_no_prices' | translate }}</span>
    <span *ngIf="event.isFreeEntry && !event.isSoldout" class="label label-rounded label-success">{{ 'is_free_entry' | translate }}</span>

    <!-- WATCH STREAM -->
    <online-event-watch-stream-icon [event]="event" (hasNoTicket)="hasNoTicket.emit()"></online-event-watch-stream-icon>

    <!-- DATETIMES -->
    <span *ngIf="!event.isDateHidden" class="datetime">
      <span class="month text-bold">{{ event.startDate | timezone: dateTimeFormat.DATE_MONTH_SHORT }}</span>
      <span class="day text-bold">{{ event.startDate | timezone: dateTimeFormat.DATE_DAY }}</span>
      <datetime-offset class="time" [date]="event.startDate">
        {{ event.startDate | timezone: dateTimeFormat.TIME_MED }}
      </datetime-offset>
    </span>

    <!-- BUY BUTTON -->
    <button type="button" *ngIf="event.canBeSold" class="btn btn-buy btn-buy-secondary" (click)="buyTicket(event.id)">
      {{ 'admin_template_buy_tickets' | translate }}
    </button>

    <!-- IMAGE -->
    <a [routerLink]="['/event/', event.name | slugify, event.id]">
      <app-image [showOverlay]="true" [imageGuid]="event.previewImageId" [altText]="event.name + ' - ' + partnerName"></app-image>
    </a>
  </div>

  <div class="card-header">
    <!-- VENUE -->
    <div class="card-subtitle">
      <span>{{ event.venueName }}</span>
    </div>

    <!-- EVENT NAME -->
    <a class="card-title-link" title="{{ event.name }}" [routerLink]="['/event/', event.name | slugify, event.id]">
      <h2 class="card-title text-bold">{{ event.name | ellipsis }}</h2>
    </a>

    <div title="{{ event.shortDescription }}" class="card-description">{{ event.shortDescription | ellipsis: 160 }}</div>
  </div>

</div>
